var _defs, _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _path4, _rect5, _rect6, _path5, _rect7, _rect8, _path6, _rect9, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeStepGraphicDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Art",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7FB0F6;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#8e77fb;}.cls-3{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m449.4,70.69l6.5-1.11c-2.09-12.24-9.32-23.01-19.85-29.57-20.32-12.66-47.16-6.42-59.81,13.9-12.66,20.32-6.42,47.16,13.9,59.81,7.06,4.4,15.02,6.58,22.96,6.58,8.8,0,17.59-2.69,25.11-8.02l3.75-2.66-3.72-2.7c-4.89-3.56-9.95-7.07-15.13-10.55,9.08-11.91,15.8-25.68,19.94-40.88,3.19,4.48,5.39,9.65,6.33,15.19Zm-11.63-21.14c-1.69,7.19-3.97,14.07-6.83,20.57-5.82-3.33-11.58-6.86-17.16-10.53-1.26-.83-2.52-1.67-3.78-2.53,1.36-1.21,2.77-2.38,4.23-3.48,5.14-3.86,10.84-6.95,16.57-9,.59.32,1.18.66,1.75,1.02,1.87,1.16,3.6,2.49,5.21,3.94Zm-15.76-8.41c-4.08,1.98-8.05,4.39-11.74,7.17-2.04,1.53-3.98,3.17-5.83,4.89-1.87-1.33-3.74-2.67-5.58-4.03-1.65-1.22-3.3-2.47-4.94-3.73,8.34-5.07,18.49-6.69,28.09-4.3Zm-40.17,16.26c1.86-2.99,4.1-5.62,6.6-7.87,2.15,1.67,4.32,3.33,6.51,4.95,1.6,1.18,3.21,2.34,4.83,3.5-1.17,1.31-2.29,2.66-3.35,4.06-3.13,4.11-5.73,8.46-7.78,13.03-3.77-2.16-7.58-4.3-11.46-6.4.88-3.89,2.42-7.69,4.64-11.26Zm-5.54,18.29c3.36,1.84,6.67,3.71,9.95,5.6-1.3,3.96-2.23,8.06-2.75,12.29-.19,1.53-.31,3.08-.4,4.64-4.67-6.58-7.04-14.53-6.8-22.52Zm13.37,29.58c-.19-3.68-.07-7.34.37-10.88.42-3.33,1.1-6.57,2.06-9.71,7.32,4.31,14.41,8.7,21.28,13.17-4.19,4.79-8.81,9.22-13.86,13.23-2.02-.8-4-1.78-5.89-2.96-1.4-.87-2.72-1.83-3.97-2.85Zm40.71,4.12c-7.17,3.82-15.3,5.11-23.13,3.84,4.2-3.64,8.1-7.55,11.69-11.72,3.89,2.6,7.71,5.23,11.44,7.88Zm-35.97-31.01c1.88-4.33,4.31-8.46,7.27-12.35,1.12-1.47,2.31-2.88,3.55-4.25,1.64,1.12,3.28,2.23,4.93,3.31,5.83,3.84,11.86,7.52,17.95,10.99-3.02,5.89-6.53,11.45-10.51,16.63-7.47-4.88-15.21-9.66-23.19-14.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m456.59,118.07l-1.98-1.48c-.17-.13-4.19-3.16-8.25-7.56-5.76-6.24-8.68-12.04-8.68-17.22,0-10.56,7.95-18.22,18.91-18.22s18.91,7.66,18.91,18.22c0,5.18-2.92,10.98-8.68,17.22-4.06,4.4-8.08,7.43-8.25,7.56l-1.98,1.48Zm0-37.9c-7.25,0-12.31,4.78-12.31,11.63,0,6.19,7.65,13.97,12.31,17.92,4.66-3.95,12.31-11.73,12.31-17.92,0-5.79-3.81-11.63-12.31-11.63Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.29,
    y: 89.05,
    width: 6.6,
    height: 5.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 399.22,
    y: 316.11,
    width: 3.24,
    height: 3.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m416.27,319.71h-3.45v-3.6h3.45v3.6Zm-6.91,0h-3.45v-3.6h3.45v3.6Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 419.72,
    y: 316.11,
    width: 3.24,
    height: 3.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 399.22,
    y: 366.47,
    width: 3.24,
    height: 3.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m416.27,370.07h-3.45v-3.6h3.45v3.6Zm-6.91,0h-3.45v-3.6h3.45v3.6Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 419.72,
    y: 366.47,
    width: 3.24,
    height: 3.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 434.47,
    y: 331.22,
    width: 3.6,
    height: 3.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m438.07,348.27h-3.6v-3.45h3.6v3.45Zm0-6.91h-3.6v-3.45h3.6v3.45Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 434.47,
    y: 351.72,
    width: 3.6,
    height: 3.24
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.11,
    y: 331.22,
    width: 3.6,
    height: 3.24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m387.71,348.27h-3.6v-3.45h3.6v3.45Zm0-6.91h-3.6v-3.45h3.6v3.45Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.11,
    y: 351.72,
    width: 3.6,
    height: 3.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m398.87,333.08h-30.34v-30.34h30.34v30.34Zm-23.74-6.6h17.14v-17.14h-17.14v17.14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.66,333.08h-30.34v-30.34h30.34v30.34Zm-23.74-6.6h17.14v-17.14h-17.14v17.14Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m398.87,383.44h-30.34v-30.34h30.34v30.34Zm-23.74-6.6h17.14v-17.14h-17.14v17.14Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.66,383.44h-30.34v-30.34h30.34v30.34Zm-23.74-6.6h17.14v-17.14h-17.14v17.14Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m389.79,476.83c-.06-.62-1.31-15.23,8.13-25.31,5.89-6.29,14.49-9.33,25.56-9.02l-.19,6.6c-9.06-.25-15.97,2.07-20.52,6.9-7.41,7.87-6.41,20.1-6.4,20.22l-6.58.61Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m439.34,517.64h-56.49v-42.32h56.49v42.32Zm-49.88-6.6h43.28v-29.11h-43.28v29.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m377.91,215.35c0-18.3,14.89-33.19,33.19-33.19,8.64,0,16.52,3.32,22.43,8.75-2.33-.71-4.81-1.09-7.37-1.09-14.07,0-25.52,11.45-25.52,25.52h0s7.4,0,7.4,0h0c0-9.99,8.13-18.13,18.13-18.13s17.62,7.63,18.1,17.19c0,.31.02.62.02.93h0s7.4,0,7.4,0h0c0-.44-.01-.88-.03-1.31-.7-21.77-18.61-39.27-40.55-39.27s-40.58,18.21-40.58,40.58h0s7.4,0,7.4,0h0Z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.51,
    y: 222.41,
    width: 93.17,
    height: 7.3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.51,
    y: 236.4,
    width: 93.17,
    height: 7.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 126.52,
    width: 6,
    height: 12.88
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 151.09,
    width: 6,
    height: 12.88
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 254.49,
    width: 6,
    height: 12.88
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 279.07,
    width: 6,
    height: 12.88
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 394.24,
    width: 6,
    height: 12.88
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 418.81,
    width: 6,
    height: 12.88
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 528.43,
    width: 6,
    height: 12.88
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 408.09,
    y: 553.01,
    width: 6,
    height: 12.88
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m455.43,640.97v-64.29h-89.01v64.29h41.21v9.88h-17.3v6.6h41.21v-6.6h-17.3v-9.88h41.21Zm-82.41-57.69h75.82v51.09h-75.82v-51.09Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.39,623.72c0-14.08,11.45-25.53,25.53-25.53,6.65,0,12.71,2.56,17.26,6.73-1.8-.54-3.7-.84-5.67-.84-10.83,0-19.63,8.81-19.63,19.63h0s5.69,0,5.69,0h0c0-7.69,6.25-13.94,13.94-13.94s13.55,5.87,13.93,13.23c0,.24.02.48.02.72h0s5.69,0,5.69,0h0c0-.34,0-.67-.03-1.01-.54-16.75-14.32-30.21-31.19-30.21s-31.22,14.01-31.22,31.22h0s5.69,0,5.69,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeStepGraphicDarkMode);
export default __webpack_public_path__ + "static/media/WelcomeStepGraphicDarkMode.d790eb28e5b1ce6eb6f92e909b8353b4.svg";
export { ForwardRef as ReactComponent };